import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiHome } = FiIcons;

function Confirmation({ onNavigate }) {
  useEffect(() => {
    // Auto-reset after 10 seconds
    const timer = setTimeout(() => {
      onNavigate('welcome');
    }, 10000);

    return () => clearTimeout(timer);
  }, [onNavigate]);

  return (
    <div className="space-y-6 text-center">
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 200, damping: 20 }}
        className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6"
      >
        <SafeIcon icon={FiCheck} className="w-10 h-10 text-green-600" />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        <h2 className="text-2xl font-bold text-slate-800 mb-4">
          All Set!
        </h2>
        <div className="text-6xl mb-4">✅</div>
        <p className="text-slate-600 leading-relaxed">
          Thanks for checking in! Jason's got your knives and will text you when they're honed and ready for pickup. Have a great day!
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
        className="space-y-3"
      >
        <button
          onClick={() => onNavigate('welcome')}
          className="w-full bg-[#0C1C35] text-white py-4 rounded-xl font-medium hover:bg-blue-900 transition-colors flex items-center justify-center gap-2"
        >
          <SafeIcon icon={FiHome} className="w-5 h-5" />
          Done
        </button>
        
        <p className="text-xs text-slate-500">
          Automatically returning to start in 10 seconds...
        </p>
      </motion.div>
    </div>
  );
}

export default Confirmation;